"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIntentSlotSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const LexResourceNamePattern = /^([0-9a-zA-Z][_-]?)+$/;
exports.AccountIntentSlotSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    intentId: yup_lib_1.default.string().required(),
    name: yup_lib_1.default
        .string()
        .matches(LexResourceNamePattern, 'Please enter intent slot name consisting Alphabet, Number, _ & -')
        .required()
        .max(100, 'Must be maximum of 100 character'),
    description: yup_lib_1.default.string().optional().min(0).max(200),
    slotTypeName: yup_lib_1.default.string().required().min(1).max(100),
    priority: yup_lib_1.default.number().integer().required().min(0),
    slotConstraint: yup_lib_1.default.string().oneOf(data_1.SlotConstraintOptions).required(),
    multipleValuesSetting: yup_lib_1.default.boolean().optional().default(false),
    obfuscationSetting: yup_lib_1.default.string().oneOf(data_1.ObfuscationSettingsOptions).required(),
    maxRetries: yup_lib_1.default.number().integer().required().min(0).max(5),
    ellicitedMessage: yup_lib_1.default.string().optional().min(1).max(200)
});
